import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFullscreen1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"fullscreen-1"} maskId="square-filled-radius-0-stroke-1-IconFullscreen1"><path d="M3 14V19H8V20H2V14H3ZM22 14V20H16V19H21V14H22ZM8 4V5H3V10H2V4H8ZM22 4V10H21V5H16V4H22Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFullscreen1;
